import * as styles from "./BreadcrumbList.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { BreadcrumbListProps } from "./Breadcrumb.types";

export function BreadcrumbList({
  children,
  className,
}: BreadcrumbListProps): JSX.Element {
  return (
    <ol data-slot="breadcrumb-list" className={clsx(styles.list, className)}>
      {children}
    </ol>
  );
}
